var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarkerBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99 99",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#5959ff",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "m11 38c0-21 18-38 39-38 21 0 38 17 38 38 0 24-25 34-39 61-13-28-38-37-38-61zm37-11c-2 0-3 1-5 2-4 2-7 7-6 13 0 6 6 12 14 11 7-1 13-7 12-14 0-2-1-4-2-5-1-2-2-3-3-4-2-2-6-3-10-3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerBlue);
export default __webpack_public_path__ + "static/media/map-marker-blue.03c9e1dcd9e0a8b4a63c769d65b02e4a.svg";
export { ForwardRef as ReactComponent };